import api from './client';

export interface UiBookmark<T = Record<string, unknown>> {
  namespace: string;
  /** null when the user has never saved a view for this grid (or has reset it). */
  config: T | null;
}

/** Per-user saved grid views — columns, filters, sort, page size. */
export const uiBookmarks = {
  get: async <T>(namespace: string): Promise<UiBookmark<T>> => {
    const res = await api.get(`/ui-bookmarks/${namespace}`);
    return res.data;
  },

  save: async <T>(namespace: string, config: T): Promise<UiBookmark<T>> => {
    const res = await api.put(`/ui-bookmarks/${namespace}`, { config });
    return res.data;
  },

  reset: async (namespace: string): Promise<UiBookmark> => {
    const res = await api.delete(`/ui-bookmarks/${namespace}`);
    return res.data;
  },
};
